import useMediaQueryCustom from '@src/hooks/useMediaQueryCustom';
import DesktopFooter from './DesktopFooter';
import MobileFooter from './MobileFooter';

const ResponsiveFooter = (props: any) => {
  const { width } = props;
  const { isMobile } = useMediaQueryCustom(
    undefined,
    width
      ? {
          width: width,
        }
      : undefined,
  );

  return isMobile ? <MobileFooter {...props} /> : <DesktopFooter {...props} />;
};

export default ResponsiveFooter;
